import { useNavigate, useLocation } from 'react-router-dom';
import { useEffect, useState, useCallback } from 'react';
import { useBlocker } from './useBlocker';


export const useCallbackPromt = (when: boolean, state: any, confirmCallback: () => void): (boolean | (() => void))[] => {
  const navigate = useNavigate()
  const location = useLocation()
  const [showPromt, setShowPromt] = useState(false)
  const [lastLocation, setLastLocation] = useState<any>(null)
  const [confirmedNavigation, setConfirmedNavigation] = useState(false)

  const cancelNavigation = useCallback(() => {
    setShowPromt(false)
  }, [])

  const handleBlockedNavigation = useCallback(
    (nextLocation) => {
      if(!confirmedNavigation && nextLocation.location.pathname !== location.pathname) {
        setShowPromt(true)
        setLastLocation(nextLocation)
        return false
      }
      return true
    }, [confirmedNavigation])

  const confirmNavigation = useCallback(() => {
    setShowPromt(false)
    setConfirmedNavigation(true)
    confirmCallback()
  }, [])

  useEffect(() => {
    if(!when && lastLocation !== null) {
      navigate(lastLocation.location.pathname, {state: {state}})
    }
    if(confirmedNavigation && lastLocation) {
      navigate(lastLocation.location.pathname, {state: {state}})
    }
  }, [confirmedNavigation, lastLocation])

  useBlocker(handleBlockedNavigation, when)

  return [showPromt, confirmNavigation, cancelNavigation]
}